module.exports = __webpack_public_path__ + "img/我爱我家@2x.d93dd750.png";